
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.221","height":"16","viewBox":"0 0 13.221 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M12.28 4.975v8.515A2.506 2.506 0 019.77 16H3.5a2.544 2.544 0 01-2.559-2.51V4.975H.807A.8.8 0 010 4.168V2.555a.8.8 0 01.807-.807h2.958v-.672A1.091 1.091 0 014.84 0h3.541a1.091 1.091 0 011.076 1.076v.672h2.958a.8.8 0 01.807.807v1.613a.8.8 0 01-.807.807zm-10.443 0v8.515A1.645 1.645 0 003.5 15.1h6.27a1.607 1.607 0 001.613-1.613V4.975zm2.824-3.227h3.9v-.672A.193.193 0 008.381.9H4.84a.193.193 0 00-.179.179zm7.664.9H.9v1.43h11.425z"}}),_c('path',{staticClass:"a",attrs:{"d":"M4.616 6.994a.45.45 0 01.9 0v5.689a.45.45 0 01-.9 0zM7.709 6.994a.45.45 0 01.9 0v5.689a.45.45 0 01-.9 0z"}})])
          )
        }
      }
    